import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 20px;
  padding-left: 20px;
  
  ${({ theme }) => theme.max("sm")`
    margin-top: 16px;
  `}
`;

export const Icon = styled.img`
  flex-shrink: 0;
`;

export const Text = styled.div`
  color: #6B7280;
  font-family: Inter;
  font-size: 14px;
  line-height: 150%;
  
  ${({ theme }) => theme.max("sm")`
    font-size: 12px;
  `}
`;
